import React from 'react'
import PropTypes from 'prop-types'
import { has, get, toNumber } from 'lodash'
import EnhancedInput from 'common/components/EnhancedInput'
import DollarOffInput from './dollarOff'
import PercentageOffInput from './percentOff'
import EventInput from './event'
import BogoInput from './bogo'
import first from 'lodash/first'
import { useTranslation } from "react-i18next";

const CustomValuesInput = (
  {
    type,
    values,
    touched,
    errors,
    handleChange
  }) => {
  const { offer_template: offerTemplate } = values
  const { t } = useTranslation();

  if (type === 'bogo') {
    return (
      <BogoInput
        buyValue={get(values, 'custom_values.buyValue')}
        getValue={get(values, 'custom_values.getValue')}
        touched={touched}
        errors={errors}
        onChange={(value, name) => {
          handleChange({ ...values.custom_values, [name]: value })
        }}
      />
    )
  }
  if (type === 'event') {
    const { template_options: templateOptions } = offerTemplate
    const option = first(templateOptions.filter(option => option.optionName === 'eventType'))
    return (
      <EventInput
        option={option}
        values={values}
        touched={touched}
        errors={errors}
        handleChange={handleChange}
      />
    )
  }
  return (
    <EnhancedInput
      id='offerValue'
      type='text'
      label={type === 'dollar-off' ? t("offer_create.basic_dollar_label") : t("offer_create.basic_percentage_label")}
      value={
        type === 'dollar-off'
          ? values.custom_values.dollarValue
          : values.custom_values.percentValue
      }
      onChange={event =>
        handleChange(
          type === 'dollar-off'
            ? { 'dollarValue': toNumber(event.target.value) }
            : { 'percentValue': toNumber(event.target.value) }
        )
      }
      inputComponent={
        type === 'dollar-off'
          ? DollarOffInput
          : PercentageOffInput}
      error={touched.offerValue && has(errors, 'offerValue')}
      helperText={touched.offerValue && get(errors, 'message')}
    />
  )
}

CustomValuesInput.propTypes = {
  type: PropTypes.string.isRequired,
  values: PropTypes.shape({
    template: PropTypes.shape({
      template_options: PropTypes.array
    })
  }),
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
}

export default CustomValuesInput
